import React from 'react';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import PText from '../components/PText';
// import Button from '../components/Button';
// import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';
import Aboutimg from '../assets/images/aboutimg.png';
import CPButton from '../components/CPButton';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Sagar Soneja</span>
              </p>
              <h2 className="about__heading">A Software Developer</h2>
              <div className="about__info">
                <PText>
                  I am working as a Software Developer at Konciv, a fast-growing
                  software company delivering innovative software solutions to
                  some of Norway's largest corporations. I have a background in
                  Software Engineering with a Bachelor's degree in Engineering.
                  <br />
                  <br />
                  In my role at Konciv, I work on a diverse range of tasks from
                  software development to customer implementation, leveraging my
                  wide skill set in technology and programming. I have developed
                  and configured custom front-end portals and reports for
                  customer implementations, collaborated with the product
                  development team to contribute to the evolution of the Konciv
                  platform ( Core Product ), I possess strong problem-solving
                  skills. My key work ethics include dedication and a tenacious
                  commitment to achieving results, and I am always open to
                  challenging opportunities and roles.
                  <br />
                  <br />
                  I am from Agra, U.P., India. A place of Taj and its beauty. I
                  am Engineering Student. Since my childhood, i love art and
                  design. I also love to create things that can be useful to
                  others.
                  <br /> <br />I started coding since I was in 11<sup>th</sup>
                  Class. Coding is also an art for me. I love it and now I have
                  the opportunity to design along with the coding. I find it
                  really interesting and I enjoyed the process a lot. I also
                  love Problem Solving.
                  <br />
                  <br />
                  My vision is to make the world a better place. Now almost
                  everything is becoming better than ever. It is time for us to
                  create more good stuff that helps the world to become a better
                  place.
                </PText>
              </div>
              <CPButton
                btnText="Download CV"
                btnLink="https://drive.google.com/file/d/1-bXMvz9g6URxS6QX9H_wFXsAz31Cn3Xo/view?usp=sharing"
                outline="true"
              />
            </div>
            <div className="right">
              <Fade>
                <img src={Aboutimg} alt="me" />
              </Fade>
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>
              <AboutInfoItem
                title="College"
                items={['Rajasthan Technical University , Kota']}
              />
              <AboutInfoItem
                title="Sec. School"
                items={['D.B.M. Senior Secondary School, Agra']}
              />
              <AboutInfoItem
                title="High School"
                items={['All Saints School , Agra']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="Languages"
                items={['C/C++', 'JavaScript', 'TypeScript']}
              />
              <AboutInfoItem
                title="Frameworks"
                items={['Angular', 'ReactJS', 'ExpressJS', 'Mongoose']}
              />
              <AboutInfoItem
                title="Databases"
                items={['MongoDB', 'Firebase', 'MySQL']}
              />
              <AboutInfoItem
                title="O.S."
                items={['Windows', 'Ubuntu', 'macOS']}
              />
              <AboutInfoItem
                title="Version Cont."
                items={['Git (Github, Gitlab)']}
              />
              <AboutInfoItem
                title="Familiar With"
                items={['REST', 'Microsoft Azure', 'Figma', 'Git']}
              />
              <AboutInfoItem
                title="Course Work"
                items={[
                  'Object-Oriented Design',
                  'Algorithm Design',
                  'Data Structures and Complexity Analysis',
                  'Problem Solving',
                  'Operating System',
                ]}
              />
            </div>
            <div className="about__info__item" />
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
